import { useState, useEffect, useRef } from 'react';
import { debounce } from 'lodash';

const useResize = () => {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const debouncedHandleResize = useRef(
    debounce(() => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, 250),
  ).current;
  useEffect(() => {
    return () => {
      debouncedHandleResize.cancel();
    };
  }, [debouncedHandleResize]);

  useEffect(() => {
    // @ts-ignore
    window.addEventListener('resize', () => debouncedHandleResize());

    return () => {
      // @ts-ignore
      window.removeEventListener('resize', () => debouncedHandleResize());
    };
  }, []);

  return dimensions;
};

export default useResize;
